export default __webpack_public_path__ + "static/media/poker.2aaa1bae.svg";